import { Friend } from './ContextProviders/friendContextTypes';

function buildEvent(
  teamId: string,
  inviteCode: string,
  campaignId: string,
  campaignName: string,
  cta: string,
  paymentMethod: string | undefined,
  userId: string | undefined,
): any {
  const eventData: any = {
    team_id: teamId,
    invite_code: inviteCode,
    device: window.fffAnalytics.sessionInfo.device.type.toLowerCase(),
    cta_name: cta,
    campaign_id: campaignId,
    campaign_name: campaignName,
  };

  if (paymentMethod) {
    eventData.paymentMethod = paymentMethod;
  }

  if (userId) {
    eventData.userId = userId;
  }
  return eventData;
}

// eslint-disable-next-line consistent-return
async function waitForAnalyticsToBeAvailable() {
  if (typeof window.analytics !== 'undefined') {
    return true;
  }
  setTimeout(waitForAnalyticsToBeAvailable, 250);
}

export const trackPageView = async (page: string) => {
  await waitForAnalyticsToBeAvailable().then(() => {
    window.analytics.page(page, {
      role: null,
      subscription_state: null,
      device: window.fffAnalytics.sessionInfo.device.type.toLowerCase(),
    });
  });
};

export const trackEvent = async (
  event: string,
  friend: Friend,
  cta: string,
  paymentMethod: string | undefined = undefined,
  userId: string | undefined = undefined,
) => {
  const {
    teamId, inviteCode, campaignId, campaignName,
  } = friend;
  await waitForAnalyticsToBeAvailable().then(() => {
    window.analytics.track(
      event, buildEvent(
        teamId, inviteCode, campaignId, campaignName, cta, paymentMethod, userId,
      ),
    );
  });
};
